<template>
  <div class='sms-input' ref="editor" @drop.prevent="false" ></div>
</template>

<script>
import Quill from 'quill'
import Delta from "quill-delta";
import { debounce } from "lodash";

export default {
  name: "editor",

  props: {
    value: String,
    debounce: {
      type: Number,
      default: 250
    }
  },

  data() {
    return {
      quill: null
    }
  },

  mounted() {
    this.injectQuill()
  },

  watch: {
    value(newValue) {
      const trimmed = this.quill.getText().trim();

      /**
       * KLUDGE: We do this cause Quill likes to add their own newlines and whitespaces we don't want process
       * and then it "updates itself"
       */
      if(newValue !== trimmed) {
        this.quill.setText(newValue);
        this.quill.setSelection(newValue.length);
      }
    }
  },

  methods: {
    injectQuill() {
      this.quill = new Quill(this.$refs.editor, {
        modules: { toolbar: false, subLabel: {} },
        placeholder: "add text...",
        theme: 'snow'
      })

      this.quill.root.setAttribute('spellcheck', false)
      this.quill.root.setAttribute('data-cy', 'stashboard-content-editor')
      this.quill.clipboard.addMatcher(Node.TEXT_NODE, (node, delta) => {
        if(node.parentElement && node.parentElement.tagName === 'SPAN' && node.data === this.mockUrl) {
          return new Delta();
        }

        return delta;
      });

      this.quill.setText(this.value)
      this.quill.on('text-change', debounce(() => {
        /**
         * KLUDGE: We do this cause Quill likes to add their own newlines and whitespaces we don't want process
         * and then it "updates itself"
         */
        const trimmed = this.quill.getText().trim();
        if(trimmed !== this.value) {
          this.$emit('update:value', trimmed)
        }
      }, this.debounce))

      const editor = this.$el.querySelector('.ql-editor');
    },

    insertText(text) {
      const cursorIndex = this.quill.getSelection(true) ? this.quill.getSelection(true).index : 0;
      this.quill.insertText(cursorIndex, text);
    }
  }
}
</script>

<style scoped>
  .sms-input {
    height: 275px;
    border: 1px solid #A6D4FC;
    border-bottom: none;
    font-size: 16px;
    font-family: AileronLight;
    font-weight: 400;
  }

  .sms-input .ql-editor {
    padding: 10px 8px;
  }
</style>
